import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "col-sm-3 col-lg-3 col-xl-3 text-center",
  id: "businessname"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-sm-12",
  id: "sponsors",
  style: {"margin-left":"-12px","padding-bottom":"10px"}
}, [
  /*#__PURE__*/_createElementVNode("h2", null, " SPONSORS ")
], -1)
const _hoisted_4 = ["id"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "business-text" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "centered-text text-center" }, [
    /*#__PURE__*/_createElementVNode("p", null, "BUISNESS NAME")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "centered-para text-center" }, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createElementVNode("em", null, "Lorem ipsum dolor sit amet, consectetur adipiscing elit")
    ])
  ])
], -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalSponsors, (sponsor) => {
        return (_openBlock(), _createElementBlock("div", {
          key: sponsor,
          class: "col-sm-12 col-lg-12 col-xl-12 text-center",
          id: 'businessname'+sponsor
        }, _hoisted_6, 8, _hoisted_4))
      }), 128))
    ])
  ]))
}